import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import {
    Container,
    Grid,
    Typography,
    Paper,
    List,
    ListItem,
    ListItemText,
    ThemeProvider,
    createTheme,
    Box,
    TextField,
    Button,
    InputLabel,
    FormControl,
} from '@mui/material';
import { useAuth } from '../../Auth/AuthProvider';
import { representanteempresaCreate, representanteempresaShow } from '../../Conections/EmpresaConection';
import { empresaDataAPI } from '../../Conections/EmpresaConection';
import { useNavigate, useParams } from 'react-router-dom';

import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import CircleIcon from '@mui/icons-material/Circle';
import { can } from '../../Conections/LogConections';

const theme = createTheme();

export default function CreateRepresentative() {

    const { getToken, getCompany } = useAuth();
    const goTo = useNavigate();
    const idCompany = useParams();

    const [name, setName] = React.useState('');
    const [last, setLast] = React.useState('');
    const [dtype, setDtype] = React.useState('');
    const [dnumber, setDnumber] = React.useState('');

    const [company, setCompany] = React.useState('');
    const [cnumber, setCnumber] = React.useState('');
    const [address, setAddress] = React.useState('');
    const [phone, setPhone] = React.useState('');
    const [web, setWeb] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [description, setDescription] = React.useState('');
    const [logo, setLogo] = React.useState('');
    const [ccolor, setCcolor] = React.useState(
        <CircleIcon sx={{ color: "#222222", gap: 2 }} />
    );

    const [errorResponse, setErrorResponse] = React.useState("");

    const TypeSelect = [
        { value: 1, name: "Cedula" },
        { value: 2, name: "Nit" },
    ];

    const OptionItems = TypeSelect.map((type, index) =>
        <MenuItem value={type.value} key={index}>
            {type.name}
        </MenuItem>
    );

    React.useEffect(() => {
        reloaduser();
    }, []);

    async function reloaduser() {
        if (getToken()) {
            const represPermisionCan = await can(getToken(), getCompany(), "/dashboard/com/createrepresentative/:id");
            if (represPermisionCan) {
                const company = await empresaDataAPI(getToken(), getCompany(), idCompany.id);
                const representative = await representanteempresaShow(getToken(), idCompany.id);
                setCompany(company.name);
                setCnumber(company.nit);
                setAddress(company.address);
                setPhone(company.phone);
                setWeb(company.web);
                setEmail(company.email);
                setDescription(company.description);
                setLogo(company.datos_base64);
                setCcolor(<CircleIcon sx={{ color: company.color, gap: 2 }} />);

                if (representative) {
                    setName(representative.name);
                    setLast(representative.lastname);
                    setDnumber(representative.docnumber);
                }
            }
            else {
                goTo("/dashboard")
            }

        }
        else {
            goTo("/login")
        }
    }

    async function handleSubmit(e) {
        e.preventDefault();
        var errors = 0;
        try {
            if (name === "") {
                setErrorResponse("Name can not be empty");
                errors++;
            }
            if (last === "") {
                setErrorResponse("Last name can not be empty");
                errors++;
            }
            if (dtype === "") {
                setErrorResponse("Document type can not be empty");
                errors++;
            }
            if (dnumber === "") {
                setErrorResponse("Document number can not be empty");
                errors++;
            }
            if (errors === 0) {
                setErrorResponse("");
                await representanteempresaCreate(
                    getToken(),
                    getCompany(),
                    idCompany.id,
                    name,
                    last,
                    dtype,
                    dnumber
                );
                goTo(`/dashboard/com/showcompany/${idCompany.id}`);
            }
        } catch (error) {
            setErrorResponse("System Error");
        }
    }

    return (
        <ThemeProvider theme={theme}>
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                <Typography variant="h3" component="h1" gutterBottom align="center" sx={{ mb: 4 }}>
                    Company and Representative Information
                </Typography>

                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={3} sx={{ p: 3 }}>
                            <Typography variant="h5" component="h2" gutterBottom>
                                Company Data
                            </Typography>
                            <Box display="flex" justifyContent="center" >
                                <img
                                    src={`data:image/jpeg;base64,${logo}`}
                                    alt={"Imagen"}
                                    width={200}
                                    loading="lazy"
                                />
                            </Box>
                            <List>
                                <ListItem>
                                    <ListItemText primary="Name" secondary={company} />
                                </ListItem>
                                <ListItem>
                                    <ListItemText primary="Nit" secondary={cnumber} />
                                </ListItem>
                                <ListItem>
                                    <ListItemText primary="Address" secondary={address} />
                                </ListItem>
                                <ListItem>
                                    <ListItemText primary="Phone" secondary={phone} />
                                </ListItem>
                                <ListItem>
                                    <ListItemText primary="Web" secondary={web} />
                                </ListItem>
                                <ListItem>
                                    <ListItemText primary="Email" secondary={email} />
                                </ListItem>
                                <ListItem>
                                    <ListItemText primary="Description" secondary={description} />
                                </ListItem>
                                <ListItem>
                                    <ListItemText primary="Color" secondary={ccolor} />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Paper elevation={3} sx={{ p: 3 }}>
                            <Typography variant="h5" component="h2" gutterBottom>
                                Representative Data
                            </Typography>
                            {!!errorResponse && <div className="errorMessage">{errorResponse}</div>}
                            <form onSubmit={handleSubmit} >
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Name"
                                            name="name"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            required
                                            InputProps={{
                                                startAdornment: <PersonOutlineIcon sx={{ mr: 1, color: 'action.active' }} />,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Last Name"
                                            name="last"
                                            value={last}
                                            onChange={(e) => setLast(e.target.value)}
                                            required
                                            InputProps={{
                                                startAdornment: <PersonOutlineIcon sx={{ mr: 1, color: 'action.active' }} />,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl fullWidth>
                                            <InputLabel id="documentLabel">Type</InputLabel>
                                            <Select
                                                labelId="documentLabel"
                                                id="documentLabelid"
                                                value={dtype}
                                                label="dtype"
                                                onChange={(e) => setDtype(e.target.value)}
                                            >
                                                {OptionItems}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Document Number"
                                            name="dnumber"
                                            value={dnumber}
                                            onChange={(e) => setDnumber(e.target.value)}
                                            required
                                            InputProps={{
                                                startAdornment: <PersonOutlineIcon sx={{ mr: 1, color: 'action.active' }} />,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            size="large"
                                        >
                                            Create Representative
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </ThemeProvider>
    );

    /*return (
        <Box sx={{ minWidth: 120 }}>
            <h1>Create Company Representative</h1>
            {!!errorResponse && <div className="errorMessage">{errorResponse}</div>}
            <form onSubmit={handleSubmit} >
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6} lg={3} >
                        <FormControl fullWidth>
                            <InputLabel htmlFor="form-name">Name</InputLabel>
                            <Input id="form-name" aria-describedby="my-helper-text" value={name} onChange={(e) => setName(e.target.value)} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3} >
                        <FormControl fullWidth>
                            <InputLabel htmlFor="form-lastname">Last Name</InputLabel>
                            <Input id="form-lastname" aria-describedby="my-helper-text" value={last} onChange={(e) => setLast(e.target.value)} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Document Type</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={dtype}
                                label="Document Type"
                                onChange={handleChange}
                            >
                                {OptionItems}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3} >
                        <FormControl fullWidth>
                            <InputLabel htmlFor="form-dnumber">Document Number</InputLabel>
                            <Input id="form-dnumber" aria-describedby="my-helper-text" value={dnumber} onChange={(e) => setDnumber(e.target.value)} />
                        </FormControl>
                    </Grid>
                    <Grid item textAlign="center" xs={12}>
                        <button>Create</button>
                    </Grid>
                </Grid>

            </form>
        </Box>
    );*/
}